module.exports = __webpack_public_path__ + "img/ice-cave.ed6d7b8c.jpg";